export const TRIAL_PAGES_V4D = 'v4d';
